/**
 * configurator-ui.js
 * - Mobile preview toggle: shrink/enlarge the 3D preview
 * - Inject configured price into sticky ATC bar
 * - Reset state on resize to desktop
 */
(function () {
  "use strict";

  var STORAGE_KEY = "tcs_cfg_controls_mode";
  var CONTROLS_CLASS = "cfg-controls-mode";
  var TOGGLE_SELECTOR = ".cfg-preview-toggle";
  var WRAPPER_SELECTOR = ".wt-product__wrapper--visualizer";
  var MOBILE_BREAKPOINT = 750;

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function getStoredState() {
    try { return localStorage.getItem(STORAGE_KEY) === "1"; } catch (e) { return false; }
  }

  function setStoredState(active) {
    try { localStorage.setItem(STORAGE_KEY, active ? "1" : "0"); } catch (e) {}
  }

  function applyState(active) {
    var html = document.documentElement;

    if (active) html.classList.add(CONTROLS_CLASS);
    else html.classList.remove(CONTROLS_CLASS);

    // Update button label if present
    var btns = document.querySelectorAll(TOGGLE_SELECTOR);
    for (var i = 0; i < btns.length; i++) {
      var labelEl = btns[i].querySelector(".cfg-preview-toggle__label");
      if (labelEl) labelEl.textContent = active ? "Enlarge" : "Minimise";
      btns[i].setAttribute("aria-pressed", active ? "true" : "false");
    }
  }

  function insertToggleButton() {
    var wrapper = document.querySelector(WRAPPER_SELECTOR);
    if (!wrapper) return;

    var vizWrapper =
      wrapper.querySelector(".visualizer__wrapper:not(.visualizer__wrapper_hidden)") ||
      wrapper.querySelector(".visualizer__wrapper");

    if (!vizWrapper) return;
    if (vizWrapper.querySelector(TOGGLE_SELECTOR)) return;

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "cfg-preview-toggle";
    btn.setAttribute("aria-pressed", "false");
    btn.setAttribute("aria-label", "Toggle between preview and options view");
    btn.innerHTML =
      '<span class="cfg-preview-toggle__icon">' +
        '<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M3 5.5L7 9.5L11 5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>" +
      "</span>" +
      '<span class="cfg-preview-toggle__label">More Options</span>';

    btn.addEventListener("click", function () {
      var isActive = document.documentElement.classList.contains(CONTROLS_CLASS);
      var next = !isActive;
      applyState(next);
      setStoredState(next);
    });

    vizWrapper.appendChild(btn);
  }

  function syncStickyPrice() {
    var sticky = document.querySelector(WRAPPER_SELECTOR + " .product-form__buttons--sticky");
    if (!sticky) return;

    var submit = sticky.querySelector(".product-form__submit");
    if (!submit) return;

    // If we already injected it, stop.
    if (submit.querySelector(".submit-button__price")) return;

    // Find the visible configured price (try common theme patterns)
    var priceSource =
      document.querySelector(WRAPPER_SELECTOR + " .price .price-item--regular") ||
      document.querySelector(WRAPPER_SELECTOR + " .price .price-item") ||
      document.querySelector(WRAPPER_SELECTOR + " .product__price .price-item") ||
      document.querySelector(WRAPPER_SELECTOR + " [data-product-price]");

    if (!priceSource) return;

    var wrapper = submit.querySelector(".submit-button__wrapper");
    if (!wrapper) {
      wrapper = document.createElement("span");
      wrapper.className = "submit-button__wrapper";
      submit.insertBefore(wrapper, submit.firstChild);
    }

    var price = document.createElement("span");
    price.className = "submit-button__price";
    price.innerHTML = '<span class="price-item">' + priceSource.textContent.trim() + "</span>";

    var tax = document.createElement("span");
    tax.className = "submit-button__tax";
    tax.textContent = "Tax included";

    wrapper.innerHTML = "";
    wrapper.appendChild(price);
    wrapper.appendChild(tax);
  }

  function init() {
    var wrapper = document.querySelector(WRAPPER_SELECTOR);
    if (!wrapper) return;

    if (isMobile()) {
      applyState(getStoredState());
      insertToggleButton();
    } else {
      // Desktop hard reset
      applyState(false);
      setStoredState(false);
    }

    // Price injection (repeat for async updates)
    syncStickyPrice();
    setTimeout(syncStickyPrice, 400);
    setTimeout(syncStickyPrice, 1200);
    setTimeout(syncStickyPrice, 2500);
  }

  var resizeTimer;
  function handleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      init();
    }, 150);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  setTimeout(init, 800);
  setTimeout(init, 2000);

  window.addEventListener("resize", handleResize);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function () {
      setTimeout(init, 250);
    });
  }
})();
